export interface SatsangiDto {
  // Existing fields
  email: string;

  // New fields for temple member information
  firstName: string;
  middleName: string;
  lastName: string;
  dateOfBirth: string;
  localMandir: string;
  nativeVillage: string;
  customNativeVillage?: string;
  mobileCountryCode: string;
  street: string;
  area: string;
  city: string;
  state: string;
  postcode: string;
  country: string;
  bloodGroup: string;
  mobileNumber: string;
  gender: string;
  maritalStatus: string;
  education: string;
  profession: string;
  isRetired: boolean;
  wouldLikeToVolunteer: boolean;
  sevaDepartments: string[];
  photo?: File | string;
  acceptDisclaimer?: boolean;
  // Explicit consent fields
  consentBloodType?: boolean;
  consentBloodTypeName?: string;
  consentBloodTypeDate?: string;
  consentRestrictedTransfer?: boolean;
  consentRestrictedTransferName?: string;
  consentRestrictedTransferDate?: string;
}

export const SatsangiDtoInit: SatsangiDto = {
  // Existing fields
  email: "",

  // New fields with initial values
  firstName: "",
  middleName: "",
  lastName: "",
  dateOfBirth: "",
  localMandir: "",
  nativeVillage: "",
  customNativeVillage: "",
  mobileCountryCode: "",
  street: "",
  area: "",
  city: "",
  state: "",
  postcode: "",
  country: "",
  bloodGroup: "",
  mobileNumber: "",
  gender: "",
  maritalStatus: "",
  education: "",
  profession: "",
  isRetired: false,
  wouldLikeToVolunteer: false,
  sevaDepartments: [],
  photo: undefined,
  acceptDisclaimer: false,
  // Explicit consent defaults
  consentBloodType: false,
  consentBloodTypeName: "",
  consentBloodTypeDate: "",
  consentRestrictedTransfer: false,
  consentRestrictedTransferName: "",
  consentRestrictedTransferDate: "",
};
